import { render, staticRenderFns } from "./CoLayout.vue?vue&type=template&id=a66fbf26&scoped=true&"
import script from "./CoLayout.vue?vue&type=script&lang=ts&"
export * from "./CoLayout.vue?vue&type=script&lang=ts&"
import style0 from "./CoLayout.vue?vue&type=style&index=0&id=a66fbf26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66fbf26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
